import type { PaletteColor } from "@mui/material/styles/createPalette";
import type { ColorPreset } from ".";
import { inkfree } from "./colors";

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
  switch (preset) {
    case "inkfree":
      return inkfree;
    default:
      return inkfree;
  }
};
